export default __webpack_public_path__ + "static/media/HomeTest.01123fb5.svg";